module.exports = __webpack_public_path__ + "img/cutout_profile_pics.dabfdcb.png";